import React, { FC } from "react";
import { useNavigate } from "react-router-dom";
import { 
  Box, 
  Button, 
  Container, 
  Header, 
  SpaceBetween,
  Icon
} from "@cloudscape-design/components";
import { ROUTES } from "src/constants";

interface AccessDeniedPageProps {
  workflowType: string;
}

/**
 * AccessDeniedPage component displayed when a user attempts to access
 * a workflow they are not authorized to use.
 * 
 * Provides a clear message about the access denial and a way to navigate
 * back to the dashboard.
 */
const AccessDeniedPage: FC<AccessDeniedPageProps> = ({ workflowType }) => {
  const navigate = useNavigate();

  const handleGoToDashboard = () => {
    navigate(ROUTES.DASHBOARD);
  };

  return (
    <Box padding="xxxl">
      <Container>
        <SpaceBetween size="l" direction="vertical" alignItems="center">
          <Box textAlign="center">
            <Icon name="status-warning" size="big" variant="warning" />
          </Box>
          
          <Header variant="h1">
            Access Denied
          </Header>
          
          <Box textAlign="center" color="text-body-secondary">
            <SpaceBetween size="xs" direction="vertical">
              <Box>
                You do not have permission to access {workflowType} workflows.
              </Box>
            </SpaceBetween>
          </Box>
          
          <Button variant="primary" onClick={handleGoToDashboard}>
            Go to Dashboard
          </Button>
        </SpaceBetween>
      </Container>
    </Box>
  );
};

export default AccessDeniedPage;
